import { UserNotificationType } from '@/types/notification.type'

const isRecord = (value: unknown): value is Record<string, unknown> =>
  Boolean(value) && typeof value === 'object' && !Array.isArray(value)

export function isUserNotificationPayload(value: unknown): value is UserNotificationType {
  if (!isRecord(value)) {
    return false
  }

  return (
    typeof value.id === 'number' &&
    typeof value.subject === 'string' &&
    typeof value.destinationUrl === 'string'
  )
}

/** Unwrap legacy `{ data: notification }` envelopes from the notification WebSocket. */
export function normalizeNotificationSocketPayload(data: unknown): UserNotificationType | null {
  if (isUserNotificationPayload(data)) {
    return data
  }

  if (isRecord(data) && isUserNotificationPayload(data.data)) {
    return data.data
  }

  return null
}
